<template>
  <div>
    <ImportDialog
      :importingError="importingError"
      :importProcessLoading="uploadLoading"
      @close="importingError = null"
    />
    <v-container fluid>
      <v-card elevation="0">
        <v-card-title class="secondary--text font-weight-medium py-0">
          <v-row>
            <v-col cols="12" class="pb-0">
              <h3 class="my-2 primary--text">
                {{ $t("layout.payments") }}
              </h3>
            </v-col>
          </v-row>
        </v-card-title>
        <v-row justify="end" align="center" class="px-5">
          <v-col class="py-0" cols="12">
            <v-row align="center" justify="end">
              <v-col cols="4" class="d-flex">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="startDate"
                      prepend-icon=""
                      :placeholder="$t('common.DDMMYY')"
                      append-icon="mdi-calendar"
                      class="white my-2 mx-1 placeholder_as_label"
                      hide-details
                      outlined
                      flat
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="endDate"
                      prepend-icon=""
                      :placeholder="$t('common.DDMMYY')"
                      append-icon="mdi-calendar"
                      class="mx-1 white my-2 placeholder_as_label"
                      dense
                      flat
                      outlined
                      hide-details
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    :min="startDate"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <v-row no-gutters>
                  <v-col cols="6" class="py-0">
                    <v-text-field
                      v-model="searchKey"
                      prepend-icon=""
                      :placeholder="$t('payments.searchByTenantOrLandlord')"
                      append-icon="mdi-magnify"
                      class="mx-1 white my-2 placeholder_as_label"
                      dense
                      flat
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-select
                      v-model="selectedPaymentStatus"
                      :placeholder="$t('payments.filterByPaymentStatus')"
                      append-icon="mdi-list-status"
                      class="mx-1 white my-2 placeholder_as_label"
                      :items="paymentStatusItem.concat('PAID')"
                      dense
                      flat
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-btn
                elevation="0"
                @click="getPaymentsByDate"
                color="primary"
                class="mx-1 white--text text-none rounded-lg"
              >
                {{ $t("common.search") }}
              </v-btn>
              <v-btn
                elevation="0"
                @click="clearALl"
                color="primary"
                class="mx-1 white--text text-none rounded-lg"
              >
                {{ $t("common.clear") }}
              </v-btn>
              <v-file-input
                ref="fileImport"
                @change="uploadFileForimport"
                v-model="fileForImport"
                accept=".xlsx,.xls"
                v-show="false"
              >
              </v-file-input>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-menu</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in downloadList"
                    :key="index"
                    @click="item.clickAction"
                  >
                    <v-list-item-icon>
                      <v-icon :color="item.color">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="black--text">{{
                      $t(item.title)
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-col>
        </v-row>
        <!-- <v-row class="mx-2">
          <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
          <v-checkbox dense outlined class="py-0 mx-2 mb-n3 my-2" v-model="isPromotionPayment">
            <template v-slot:label>
              <p class="primary--text my-0 py-0">
                {{ $t("payments.promotionPayments") }}
              </p>
            </template>
          </v-checkbox>
          <v-checkbox dense outlined class="py-0 mx-2 mb-n3 my-2" v-model="isBookingPayment">
            <template v-slot:label>
              <p class="primary--text my-0 py-0">
                {{ $t("payments.bookingPayments") }}
              </p>
            </template>
          </v-checkbox>
          <v-checkbox dense outlined class="py-0 mx-2 mb-n3 my-2" v-model="isLandlordSubscriptionPayment">
            <template v-slot:label>
              <p class="primary--text my-0 py-0">
                Landlord Subscription
              </p>
            </template>
          </v-checkbox>
        </v-row> -->
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          id="paymentTable"
          class="datatable mb-9"
          :hide-default-footer="footer"
          :headers="headers"
          :items="paymentLists"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totalPayments"
        >
          <!-- :server-items-length="totalPayments" -->
          <template v-slot:item="{ item }">
            <tr>
              <td
                class="text-center"
                :class="item.isPromotionPayment ? 'primary white--text' : ''"
              >
                <p class="my-0 py-0">
                  {{
                    options.page * options.itemsPerPage -
                      options.itemsPerPage +
                      paymentLists
                        .map(function(x) {
                          return x._id;
                        })
                        .indexOf(item._id) +
                      1
                  }}
                </p>
              </td>
              <td
                nowrap
                class="text-center"
                :class="item.isPromotionPayment ? 'primary white--text' : ''"
              >
                {{ item.customerName }}
              </td>
              <td
                class="text-center"
                :class="item.isPromotionPayment ? 'primary white--text' : ''"
              >
                {{ item.landlordName }}
              </td>
              <td
                class="text-center"
                :class="item.isPromotionPayment ? 'primary white--text' : ''"
              >
                {{ item.propertyName }}
              </td>
              <td
                class="text-center"
                :class="item.isPromotionPayment ? 'primary white--text' : ''"
              >
                {{ item.price }}
              </td>
              <td
                nowrap
                class="text-center"
                :class="item.isPromotionPayment ? 'primary white--text' : ''"
              >
                {{
                  item.date ? dateFormat(new Date(parseInt(item.date))) : "-"
                }}
              </td>
              <td
                class="text-center"
                :class="item.isPromotionPayment ? 'primary white--text' : ''"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      class="same-width-chip"
                      :color="statusChipColors[item.status]"
                      v-if="item.status"
                      x-small
                      v-bind="attrs"
                    >
                      {{ statusText[item.status] }}
                      <v-icon
                        v-on="on"
                        x-small
                        class="ml-2"
                        v-if="item.status !== 'PAID' && item.status !== 'true'"
                        color="white"
                      >
                        mdi-arrow-down
                      </v-icon>
                    </v-chip>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(i, index) in paymentStatusItem"
                      :key="index"
                      @click="paymentStatusChange(i, item)"
                    >
                      <v-list-item-title>{{ statusText[i] }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
              <td
                class="text-center"
                :class="item.isPromotionPayment ? 'primary white--text' : ''"
              >
                <span v-if="item.paymentMethod">
                  {{ item.paymentMethod }}
                </span>
              </td>
            </tr>
          </template>
          <template slot="body.append">
            <!-- v-show="isAppendBody" -->
            <tr class="">
              <td></td>
              <td></td>
              <td colspan="2" class="text-right">
                {{ $t("payments.totalAmount") }}:
              </td>
              <td class="text-center">
                {{ totalAmount ? totalAmount.toFixed(3) : "" }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <table id="payment-pdf-table" v-show="false">
        <thead>
          <tr>
            <th>S.No</th>
            <th>{{ $t("payments.customerName") }}</th>
            <th>{{ $t("payments.price") }}</th>
            <th>{{ $t("payments.date") }}</th>
            <th>{{ $t("bookings.status") }}</th>
            <th>{{ $t("payments.paymentMethod") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in exportPdf" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.customerName }}</td>
            <td>{{ item.price }}</td>
            <td>
              {{ item.date ? dateFormat(new Date(parseInt(item.date))) : "-" }}
            </td>
            <td>{{ item.status }}</td>
            <td>{{ item.paymentMethod }}</td>
          </tr>
          <tr>
            <td></td>
            <td>Price</td>
            <td>{{ totalPrice }}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-container>
  </div>
</template>

<script>
import { updatePaymentStatus } from "../methods/updatePaymentStatus";
import moment from "moment";
export default {
  data() {
    return {
      menu1: false,
      menu2: false,
      importingError: null,
      startDate: "",
      endDate: "",
      selectedPaymentStatus: null,
      searchKey: "",
      totalPrice: 0,
      fileForImport: null,
      isPromotionPayment: false,
      isBookingPayment: false,
      isLandlordSubscriptionPayment: false,
      loading: false,
      search: "",
      uploadLoading: false,
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      paymentLists: [],
      exportPdf: [],
      totalPayments: 10,
      paymentStatusItem: [],
      footer: false,
      totalAmount: 0,
      BASE_URL: process.env.VUE_APP_BASE_URL
    };
  },
  components: {
    ImportDialog: () => import("../components/ImportDialog.vue")
  },
  computed: {
    statusText() {
      return {
        PENDING: "Pending",
        Pending: "Pending",
        PAID: "Paid",
        PAYMENT_FAILED: "Failed",
        CANCELLED: "Cancelled"
      };
    },
    statusChipColors() {
      return {
        PENDING: "primary",
        Pending: "primary",
        PAID: "success",
        PAYMENT_FAILED: "error",
        CANCELLED: "error"
      };
    },
    downloadList() {
      return [
        {
          value: "excel",
          title: "common.downloadExcel",
          icon: "mdi-application-export",
          color: "success",
          clickAction: () => this.exportData("excel")
        },
        {
          value: "pdf",
          title: "common.downloadPDF",
          icon: "mdi-file-pdf-box",
          color: "error",
          clickAction: () => this.exportData("pdf")
        },
        {
          title: "common.downloadImportTemplate",
          icon: "mdi-file-excel",
          color: "success",
          clickAction: () => {
            const fileUrl =
              this.BASE_URL + "files/images/payment/payment_data.xls";
            const a = document.createElement("a");
            a.download = fileUrl;
            a.style.display = "none";
            a.href = fileUrl;
            a.click();
          }
        },
        {
          title: "common.importPaymentByExcel",
          icon: "mdi-import",
          color: "success",
          clickAction: () => {
            this.$refs.fileImport.$refs.input.click();
          }
        }
      ];
    },
    headers() {
      return [
        {
          text: "#",
          value: "_id",
          width: 10
        },
        {
          text: this.$t("payments.customerName"),
          value: "customerName"
        },
        {
          text: this.$t("landlord.landlord")
        },
        {
          text: this.$t("landlord.propertyName")
        },
        {
          text: this.$t("payments.price"),
          value: "price"
        },
        {
          text: this.$t("payments.date"),
          value: "date"
        },
        {
          text: this.$t("bookings.status"),
          value: "status"
        },
        {
          text: this.$t("payments.paymentMethod"),
          value: "paymentMethod"
        }
      ].map(header => {
        header.align = "center";
        header.sortable = false;
        header.width = header.width ? header.width : "5px";
        return header;
      });
    }
  },
  watch: {
    options() {
      this.$apollo.queries.getPaymentDetails.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalPayments,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        }
      });
    },
    isPromotionPayment() {
      let filter = {
        fromDate: this.startDate,
        toDate: this.endDate
      };
      if (this.isPromotionPayment)
        filter = {
          isPromotionPayment: this.isPromotionPayment,
          fromDate: this.startDate,
          toDate: this.endDate
        };
      this.$apollo.queries.getPaymentDetails.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalPayments,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter
      });
    },
    isBookingPayment() {
      let filter = {
        fromDate: this.startDate,
        toDate: this.endDate
      };
      if (this.isBookingPayment)
        filter = {
          isPromotionPayment: false,
          fromDate: this.startDate,
          toDate: this.endDate
        };
      this.$apollo.queries.getPaymentDetails.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalPayments,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter
      });
    },
    isLandlordSubscriptionPayment() {
      let filter = {
        fromDate: this.startDate,
        toDate: this.endDate
      };
      if (this.isLandlordSubscriptionPayment)
        filter = {
          isLandlordSubscriptionPayment: false,
          fromDate: this.startDate,
          toDate: this.endDate
        };
      this.$apollo.queries.getPaymentDetails.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalPayments,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter
      });
    }
  },
  apollo: {
    getPaymentDetails() {
      this.loading = true;
      return {
        query: require("@/payments/api/queries/payment_query.graphql"),
        variables: {
          input: {
            limit: 50,
            skip: 0
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.paymentLists = this.$format.cloneVariable(
            data.getPaymentDetails.paymentDetails
          );
          this.totalPayments = data.getPaymentDetails.totalCount;
          this.paymentLists = this.paymentLists.filter(
            x => x.status !== "MONTHLY_RENT_PENDING"
          );
          if (this.paymentLists.length) {
            this.totalAmount = Number(
              this.paymentLists
                .map(val => val.price)
                .reduce((first, next) => {
                  return Number(first) + Number(next);
                })
            );
          }
          this.loading = loading;
        }
      };
    },
    getPaymentStatusTypes() {
      return {
        query: require("@/payments/api/queries/payment_status_query.graphql"),
        result({ data }) {
          // , loading, networkStatus, refetch
          this.paymentStatusItem = this.$format.cloneVariable(
            data.getPaymentStatusTypes
          );
          // folowing block added for removing PAID mutator flag from paymentStatuses
          // This should be removed in order to show paid option in change payment status menu.
          // Block starts from here
          this.paymentStatusItem.forEach((paymentStatus, index) => {
            if (paymentStatus === "PAID") {
              this.paymentStatusItem.splice(index, 1);
            }
          });
          // Block ends here
        }
      };
    }
  },
  methods: {
    uploadFileForimport(file) {
      this.uploadLoading = true;
      this.$apollo
        .mutate({
          mutation: require("@/payments/api/mutations/import_payment_data.graphql"),
          variables: { excelFile: file }
        })
        .then(({ data }) => {
          this.uploadLoading = false;
          if (data.importPaymentData) {
            this.getPaymentsByDate();
          }
        })
        .catch(error => {
          this.uploadLoading = false;
          this.importingError = JSON.parse(error.graphQLErrors[0].message);
        });
    },
    getPaymentsByDate() {
      let filter = {
        fromDate: this.startDate,
        toDate: this.endDate,
        searchKey: this.searchKey,
        status: this.selectedPaymentStatus
      };
      if (this.isPromotionPayment)
        filter = {
          isPromotionPayment: this.isPromotionPayment,
          fromDate: this.startDate,
          toDate: this.endDate
        };
      this.$apollo.queries.getPaymentDetails.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalPayments,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter
      });
    },
    clearALl() {
      this.startDate = "";
      this.endDate = "";
      this.searchKey = "";
      this.selectedPaymentStatus = "";
      let filter = {
        fromDate: this.startDate,
        toDate: this.endDate
      };
      if (this.isPromotionPayment)
        filter = {
          isPromotionPayment: this.isPromotionPayment,
          fromDate: this.startDate,
          toDate: this.endDate
        };
      this.$apollo.queries.getPaymentDetails.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalPayments,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter
      });
    },
    exportData(type) {
      this.$apollo.queries.getPaymentDetails
        .refetch({
          input: {
            limit: 0,
            skip: 0
          }
        })
        .then(data => {
          if (type === "pdf") {
            this.exportPdf = this.$format.cloneVariable(
              data.data.getPaymentDetails.paymentDetails
            );
            this.totalPrice = Number(
              this.exportPdf
                .map(val => val.price)
                .reduce((first, next) => {
                  return Number(first) + Number(next);
                })
            );
            this.exportPdf = this.exportPdf.filter(
              x => x.status !== "MONTHLY_RENT_PENDING"
            );
            setTimeout(() => {
              this.generatePdf("Payment", "payment-pdf-table");
            }, 1000);
          } else {
            this.options.itemsPerPage = data.data.getPaymentDetails.totalCount;
            this.paymentLists = this.$format.cloneVariable(
              data.data.getPaymentDetails.paymentDetails
            );
            this.paymentLists = this.paymentLists.filter(
              x => x.status !== "MONTHLY_RENT_PENDING"
            );
            // this.unitTypeLists = response.data.searchCustomer.users
            this.footer = true;
            setTimeout(() => {
              this.htmlToExcel("paymentTable", "payment");
            }, 1000);
          }
        });
    },
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY, h:mm:ss");
    },
    openRightSideDrawer() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    showDeleteDialog(item) {
      this.$root.$emit("deleteDialog", { dialog: true, item: item });
    },
    paymentStatusChange(i, item) {
      updatePaymentStatus({
        paymentId: item._id,
        status: i
      }).then(response => {
        if (response) {
          this.loading = true;
          this.$apollo.queries.getPaymentDetails.refetch({}).then(result => {
            if (result) {
              this.loading = false;
              this.$root.$emit("snackbar", {
                snackbar: true,
                text: "Payment Status Changed Successfully",
                color: "green"
              });
            }
          });
        }
      });
    }
  },
  mounted() {
    this.$root.$on("paymentTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
  },
  beforeDestroy() {
    this.$root.$off("paymentTable");
  }
};
</script>
<style scoped>
.same-width-chip {
  width: 110px !important;
  justify-content: center;
  font-size: 14px !important;
  height: 25px !important;
}
/* .primary {
  background-color: aqua !important;
} */
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}

.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
